import { Icon, IconName } from './Icon';
import { Challenge } from '../types';
import { fmtAddress, fmtDateLong, fmtTimeRange } from '../utils/format';

/** Date, time and place, each with an icon. */
export function InfoRows({ challenge }: { challenge: Challenge }) {
  const { startsAt, endsAt, location } = challenge;
  const range = fmtTimeRange(startsAt, endsAt);
  const rows: Array<{ icon: IconName; label: string; value: string }> = [
    { icon: 'calendar', label: 'Data', value: fmtDateLong(startsAt) },
    {
      icon: 'clock',
      label: 'Horário',
      value: range === 'Dia todo' ? range : `Das ${range}`,
    },
    { icon: 'pin', label: 'Local', value: fmtAddress(location) },
  ];

  return (
    <section className="pv-card pv-inforows" aria-label="Data, horário e local">
      {rows.map((row) => (
        <div className="pv-inforows__row" key={row.label}>
          <div className="pv-icon-tile">
            <Icon name={row.icon} size={20} />
          </div>
          <div>
            <div className="pv-muted pv-small">{row.label}</div>
            <div className="pv-inforows__value">{row.value}</div>
          </div>
        </div>
      ))}
    </section>
  );
}
